import { Outlet } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import SidebarLayout from '@/layouts/SidebarLayout';
import { PopupNotification } from '@/components/PopupNotification';
import { usePopupManager } from '@/hooks/usePopupManager';
import { getMyInfo } from '@/services/user';

export default function AuthenticatedLayout() {
  const { data, isLoading } = useQuery({
    queryKey: ['myInfo'],
    queryFn: getMyInfo,
  });

  // Popup yönetimi
  const {
    currentPopup,
    currentIndex,
    totalPopups,
    closePopup,
    confirmPopup,
    nextPopup,
    previousPopup,
    skipAllPopups,
  } = usePopupManager(data || null);

  if (isLoading || !data) {
    return (
      <div className="flex items-center justify-center min-h-screen"></div>
    );
  }

  return (
    <SidebarLayout myInfo={data}>
      <Outlet />
      <PopupNotification
        popup={currentPopup}
        currentIndex={currentIndex}
        totalPopups={totalPopups}
        onClose={closePopup}
        onConfirm={confirmPopup}
        onNext={nextPopup}
        onPrevious={previousPopup}
        onSkipAll={skipAllPopups}
      />
    </SidebarLayout>
  );
}
